import { PageTreeStateUpdater } from './PageTreeStateUpdater';

const standalonePageTreeStateUpdater = new PageTreeStateUpdater();

/**
 * YOU PROBABLY SHOULD NOT USE THIS.
 *
 * This function was created to faciliate communication between the legacy monolith-rendered JS app,
 * and the modern React-based content tree.
 *
 * If you need to communicate with the content tree from some other part of the React app, you should use
 * an unstated Subscribe component instead of this function.
 *
 * This function should strictly be used by StandaloneConfluenceNavigation and the legacy message queue.
 *
 * @returns A shared instance of PageTreeStateUpdater which is intended to be used by the legacy JS app
 */
export const getStandalonePageTreeStateUpdater = () => standalonePageTreeStateUpdater;
